'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useIsGuest } from '@/hooks/useIsGuest';
import { CUSTOM_SCHEME } from '@/modules/wello-app';
import { useBenefitGate } from '../../_hooks/useBenefitGate';
import { useCountdown } from '../../_hooks/useCountdown';
import { formatCountdown } from '../../_utils/countdown';
import { useClaimCoupang, useCoupangEarn } from '../_hooks/useCoupangEarn';
import { useCoupangRecommend } from '../_hooks/useCoupangRecommend';
import { resolveCoupangCtaBlockedLabel } from '../_utils/resolveCoupangCtaBlockedLabel';
interface CoupangEarnCountdownButtonProps {
  onClickEarn: () => void;
  isPending: boolean;
}

//* rewardPoint를 아직 모르면(서버 미제공) 숫자 없이 중립 라벨로 노출한다.
const resolveEarnLabel = (rewardPoint: number | null) => rewardPoint !== null ? `쿠팡에서 ${rewardPoint}P 받기` : '쿠팡에서 웰포인트 받기';
const CoupangEarnCountdownButton = t0 => {
  const $ = _c(10);
  const {
    onClickEarn,
    isPending
  } = t0;
  const {
    data
  } = useCoupangEarn();
  const {
    isAvailable,
    secondsUntilAvailable
  } = useCountdown(data.nextAvailableAtMs);
  let t1;
  if ($[0] !== data.rewardPoint) {
    t1 = resolveEarnLabel(data.rewardPoint);
    $[0] = data.rewardPoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const earnLabel = t1;
  const t2 = !isAvailable || isPending;
  let t3;
  if ($[2] !== earnLabel || $[3] !== isAvailable || $[4] !== secondsUntilAvailable) {
    t3 = isAvailable ? earnLabel : <span suppressHydrationWarning={true} className="tabular-nums">{formatCountdown(secondsUntilAvailable)} 뒤에 참여 가능해요</span>;
    $[2] = earnLabel;
    $[3] = isAvailable;
    $[4] = secondsUntilAvailable;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClickEarn || $[7] !== t2 || $[8] !== t3) {
    t4 = <Button className="flex-1" disabled={t2} onClick={onClickEarn}>{t3}</Button>;
    $[6] = onClickEarn;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
interface CoupangEarnButtonProps {
  isGuest: boolean;
}
export const CoupangEarnButton = t0 => {
  const $ = _c(18);
  const {
    isGuest: serverIsGuest
  } = t0;
  const isGuest = useIsGuest(serverIsGuest);
  const {
    mutate: claim,
    isPending
  } = useClaimCoupang();
  const {
    triggerGate,
    gateModals
  } = useBenefitGate();
  const {
    isChecking,
    isWelloApp
  } = useCheckWelloApp();
  const {
    products,
    isLoading,
    advertisingId,
    isAdvertisingIdPending
  } = useCoupangRecommend();
  let t1;
  if ($[0] !== claim || $[1] !== products || $[2] !== triggerGate) {
    t1 = () => {
      triggerGate(["app", "login", "consent"], () => {
        const product = products[Math.floor(Math.random() * products.length)];
        window.location.href = `${CUSTOM_SCHEME.EXTERNAL_PREFIX}${product.clickUrl}`;
        claim({});
      });
    };
    $[0] = claim;
    $[1] = products;
    $[2] = triggerGate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClickEarn = t1;
  const t2 = isAdvertisingIdPending || isLoading;
  let t3;
  if ($[4] !== advertisingId || $[5] !== isChecking || $[6] !== isWelloApp || $[7] !== products.length || $[8] !== t2) {
    t3 = resolveCoupangCtaBlockedLabel({
      isChecking,
      isWelloApp,
      isResolving: t2,
      advertisingId,
      productCount: products.length
    });
    $[4] = advertisingId;
    $[5] = isChecking;
    $[6] = isWelloApp;
    $[7] = products.length;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const blockedLabel = t3;
  let t4;
  if ($[10] !== blockedLabel || $[11] !== handleClickEarn || $[12] !== isGuest || $[13] !== isPending) {
    t4 = blockedLabel ? <Button className="flex-1" disabled={true}>{blockedLabel}</Button> : isGuest ? <Button className="flex-1" onClick={handleClickEarn}>쿠팡에서 웰포인트 받기</Button> : <ErrorBoundary fallback={<Button className="flex-1" disabled={true}>쿠팡에서 웰포인트 받기</Button>}><Suspense fallback={<Button className="flex-1" disabled={true}>쿠팡에서 웰포인트 받기</Button>}><CoupangEarnCountdownButton onClickEarn={handleClickEarn} isPending={isPending} /></Suspense></ErrorBoundary>;
    $[10] = blockedLabel;
    $[11] = handleClickEarn;
    $[12] = isGuest;
    $[13] = isPending;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== gateModals || $[16] !== t4) {
    t5 = <>{t4}{gateModals}</>;
    $[15] = gateModals;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};